import {Hub} from "@aws-amplify/core"

/** @type {Object.<string, { unsubscribe: () => void}>} */
const listeners = {}

/**
 * Adds a listener, if the listener already exists,
 * it will be removed before this one is added.
 *
 * @param {string} channel
 * @param {import("@aws-amplify/core").HubCallback} callback
 */
function registerListener(channel, callback) {
  const previousListener = listeners[channel]
  if (!!previousListener) {
    previousListener.unsubscribe()
  }
  const unsubscribe = Hub.listen(channel, callback)
  listeners[channel] = {unsubscribe}
}

/**
 * Verify if a listener has been registered
 *
 * @param {string} channel
 * @returns
 */
function hasListener(channel) {
  const previousListener = listeners[channel]
  return !!previousListener
}

/**
 * Removes a hub listener
 *
 * @param {string} channel
 */
function removeListener(channel) {
  const listener = listeners[channel]
  if (!!listener) {
    listener.unsubscribe()
  }
}

const PayloadMsg = {
  OAUTH_FLOW_FAILIED: "The OAuth response flow failed",
}

const PayloadData = {
  ERR_INVALID_STATE: "Error: Invalid state in OAuth flow",
  ERR_FB_USER_DENIED:
    "Error: Permissions+error%3B+error%3Daccess_denied%3B+error_code%3D200%3B+error_reason%3Duser_denied",
}

/**
 *
 * @param {import("@aws-amplify/core").HubPayload} payload
 */
function parseSignInFailure(payload) {
  const payloadMessage = payload.message ?? ""
  const data = payload.data?.toString() ?? ""

  if (payloadMessage === PayloadMsg.OAUTH_FLOW_FAILIED) {
    if (data === PayloadData.ERR_INVALID_STATE) {
      return {error: Errors.INVALID_OAUTH_STATE}
    }

    if (data === PayloadData.ERR_FB_USER_DENIED) {
      return {error: Errors.FB_USER_DENIED}
    }
  }

  return {error: Errors.UNKNOWN}
}

const Errors = {
  /** The oauth_state is inconsistent between Amplify and session storage */
  INVALID_OAUTH_STATE: "INVALID_OAUTH_STATE",

  /** User refuse to provide personsal information (e.g. name, avatar, email...) during facebook OAuth flow */
  FB_USER_DENIED: "FB_USER_DYNIED",

  /** Unhandled cases */
  UNKNOWN: "UNKNOWN",
}

const HubHelper = {
  registerListener,
  hasListener,
  removeListener,
  parseSignInFailure,
}

export {HubHelper, Errors}
